module.exports = __webpack_public_path__ + "static/media/comment_blue.37fbdbfe.svg";